import React, { createContext, useEffect, useState } from "react";
import useFBOApi from "./api/useFBOApi";
import { useKeycloak } from "@react-keycloak/web";
import { useLogout } from "./LogoutProvider";
import SnackbarAlert from "../components/element/SnackbarAlert";
import { PROMISE_STATUS } from "../utils/constants";

const StorageContext = createContext();

const StorageProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const { fetchFBOUserProfile, fetchListOfAircraft, fetchGetFboCustomers, fetchListOfAirport, fetchListOfAirline } =
    useFBOApi();
  const [fboUserProfileData, setFBOUserProfileData] = useState(null);
  const [fboListData, setFBOListData] = useState(null);
  const [airportListData, setAirportListData] = useState(null);
  const [aircraftListData, setAircraftListData] = useState(null);
  const [airlineListData, setAirlineListData] = useState(null);
  const [error, setError] = useState(null);
  const { handleUnauthorized } = useLogout();

  useEffect(() => {
    const loadData = async () => {
      if (keycloak.authenticated) {
        try {
          const [userProfile, aircraft, fboCustomers, airports, airlineListData] = await Promise.allSettled([
            fetchFBOUserProfile(),
            fetchListOfAircraft(),
            fetchGetFboCustomers(),
            fetchListOfAirport(),
            fetchListOfAirline()

          ]);

          if (userProfile.status === PROMISE_STATUS.FULFILLED) {
            setFBOUserProfileData(userProfile.value);
          } else {
            setError(userProfile.reason);
          }

          if (aircraft.status === PROMISE_STATUS.FULFILLED) {
            setAircraftListData(aircraft.value);
          } else {
            setError(aircraft.reason);
          }

          if (fboCustomers.status === PROMISE_STATUS.FULFILLED) {
            setFBOListData(fboCustomers.value);
          } else {
            setError(fboCustomers.reason);
          }

            if (airports.status === PROMISE_STATUS.FULFILLED) {
              setAirportListData(airports.value);
            } else {
              setError(airports.reason);
            }
            if (airlineListData.status === PROMISE_STATUS.FULFILLED) {
              setAirlineListData(airlineListData.value);
            } else {
              setError(airlineListData.reason);
            }
        } catch (err) {
          setError(err);
        }
      }
    };

    loadData();
  }, [keycloak.authenticated]);

  if (error) {
    if (error.status === 404) {
      handleUnauthorized();
    } else {
      return <SnackbarAlert type={"error"}>{error.message}</SnackbarAlert>;
    }
  }

  return (
    <StorageContext.Provider
      value={{
        fboUserProfileData,
        aircraftListData,
        fboListData,
        airportListData,
        airlineListData,
      }}
    >
      {children}
    </StorageContext.Provider>
  );
};

export { StorageProvider, StorageContext };
